var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import FormInput from '@/common/components/Form/FormInput.vue';
import { isMobile } from '@/common/utils/regex';
import { getAllCompanyList } from '@/views/company/api';
import { userLogin } from '@/views/login/api/auth';
import { Vue, Component, InjectReactive, Watch, Prop } from 'vue-property-decorator';
import { rules } from '../../config/rule';
import MixinChangeStore from '@/common/mixins/changeStore';
import PrivacyModal from './PrivacyModal.vue';
import { isObject } from '@lhb/func';
import { setCookie, setStorage } from '@lhb/cache';
var webUrl = require('config/env').webUrl;
var LoginForm = /** @class */ (function (_super) {
    __extends(LoginForm, _super);
    function LoginForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.loading = false;
        _this.rules = rules;
        _this.companyId = 0;
        _this.form = {
            mobile: '',
            password: '',
        };
        _this.checkedPrivacy = false;
        _this.showPrivacyModal = false;
        return _this;
    }
    LoginForm.prototype.formMobileChange = function (newVal) {
        if (newVal && isMobile(newVal)) {
            this.$emit('update-mobile', newVal);
        }
    };
    /* hook */
    LoginForm.prototype.created = function () {
        if (this.mobile && isMobile(this.mobile)) {
            this.form.mobile = this.mobile;
        }
        // 密码修改成功时手机号带过来
        var _a = this.$route.query, mobile = _a.mobile, toPath = _a.toPath, companyId = _a.companyId;
        if (mobile) {
            if (!isMobile(mobile)) {
                this.isValid = false;
            }
            this.form.mobile = mobile;
        }
        if (toPath) { // 要跳转到指定页面
            this.toPath = decodeURIComponent(location.search.replace("?toPath=", ''));
        }
        if (companyId) {
            this.companyId = companyId;
        }
    };
    /* method */
    // 登录 原来的逻辑
    LoginForm.prototype.postLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.loading = true;
                this.$refs.loginForm.validate(function (valid) { return __awaiter(_this, void 0, void 0, function () {
                    var mobile;
                    return __generator(this, function (_a) {
                        if (valid) {
                            mobile = this.form.mobile;
                            if (!isMobile(mobile) && mobile.indexOf('@') < 0) {
                                this.loading = false;
                                return [2 /*return*/, this.$message.warning('请输入手机号')];
                            }
                            if (!this.checkedPrivacy) {
                                this.showPrivacyModal = true;
                                return [2 /*return*/];
                            }
                            this.userLogin();
                        }
                        else {
                            this.loading = false;
                            console.log('error submit!!');
                        }
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    LoginForm.prototype.userLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, mobile, password, params, strArr, res, companyRes;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.form, mobile = _a.mobile, password = _a.password;
                        params = {
                            loginType: 2,
                            password: password,
                        };
                        if (!isMobile(mobile)) {
                            strArr = mobile.split('@');
                            params.username = strArr[0];
                            params.companyName = strArr[1];
                        }
                        else {
                            params.mobile = mobile;
                        }
                        if (this.companyId) {
                            Object.assign(params, { companyId: this.companyId });
                        }
                        return [4 /*yield*/, userLogin(params).finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        res = _b.sent();
                        if (!res) return [3 /*break*/, 4];
                        if (process.env.NODE_ENV !== 'development') { // 开发环境屏蔽
                            if (isObject(res.token)) { // 如果是对象，就上报
                                // 主动send事件
                                window.LHBbigdata.send({
                                    event_id: 'location_pms_pc_cookie_monitoring_token',
                                    msg: res,
                                });
                            }
                        }
                        setCookie('newPmsToken', res.token);
                        setStorage('newPmsToken', res.token);
                        setStorage('getTokenApi', "/property/user/login");
                        setCookie('placeIds', 0);
                        if (!res.companyId) return [3 /*break*/, 2];
                        this.companyChange(res.companyId); // Mixin 中的方法
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getAllCompanyList()];
                    case 3:
                        companyRes = _b.sent();
                        if (companyRes.length === 0) {
                            return [2 /*return*/, this.$message.warning('您还没有所属公司，请联系客服人员！')];
                        }
                        if (companyRes.length > 1) {
                            this.loginData.companies = companyRes;
                            this.loginData.showChangeCompanyDialog = true;
                        }
                        else {
                            this.companyChange(companyRes[0].id); // Mixin 中的方法
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginForm.prototype.confirmPrivacy = function () {
        this.checkedPrivacy = true;
        this.userLogin();
    };
    LoginForm.prototype.closeHandle = function () {
        this.loading = false;
        this.showPrivacyModal = false;
    };
    LoginForm.prototype.userHandle = function () {
        window.open(webUrl + "/userAgreement");
    };
    LoginForm.prototype.privacyHandle = function () {
        window.open(webUrl + "/privacy");
    };
    LoginForm.prototype.toRetrevePassword = function () {
        var _a = this, form = _a.form, isValid = _a.isValid;
        this.$router.push({
            path: "/login/retrieve-password" + (form.mobile && isValid ? "?mobile=" + form.mobile : ''),
        });
    };
    __decorate([
        InjectReactive('Login')
    ], LoginForm.prototype, "loginData", void 0);
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], LoginForm.prototype, "mobile", void 0);
    __decorate([
        Watch('form.mobile')
    ], LoginForm.prototype, "formMobileChange", null);
    LoginForm = __decorate([
        Component({
            components: {
                FormInput: FormInput,
                PrivacyModal: PrivacyModal
            },
            mixins: [MixinChangeStore],
        })
    ], LoginForm);
    return LoginForm;
}(Vue));
export default LoginForm;
